import {
  getAllowedOperation,
  isAuthorizedOperation,
} from '@modules/common/components/CanAccess/utils';
import { PermissionOperation } from 'generated/graphql';
import { PermissionResourceType } from 'v2/core/entities/user';
import { useGetUser } from 'v2/core/services/user';

interface useIsAuthorizedOptions {
  operation: PermissionOperation;
  resource: PermissionResourceType;
}

export const useIsAuthorized = ({
  operation: requestedOperation,
  resource,
}: useIsAuthorizedOptions): boolean => {
  const { permissions = [] } = useGetUser();

  const allowedOperation = getAllowedOperation(permissions, resource);

  return isAuthorizedOperation(allowedOperation, requestedOperation);
};
